import { createMuiTheme } from '@material-ui/core/styles';

export type OrientationProps = {
    width: number
}

const themePrimary = createMuiTheme({
    overrides: {
        MuiTypography: {
            root:{
                fontFamily: 'LeagueSpartan-Bold !important',
                color: '#000000',
            },
            colorTextSecondary: {
                color: '#000000',
            }
        },
        MuiCheckbox: {
            root: {
                verticalAlign: 'top',
                padding: '0px 6px 0px 0px',
            },
        },
        MuiStepLabel: {
            label: {
                marginTop: '8px !important',
            },
        },
        MuiToolbar: {
            regular: {
                minHeight: '50px !important',
                height: '50px',
            }
        },
        MuiAccordion: {
            root: {
                backgroundColor: '#ffffff !important',
                '&:before': {
                    backgroundColor: '#ffffff',
                },
            },
        },
        MuiAccordionDetails: {
            root: {
                paddingLeft: '10px',
                paddingRight: '10px',
                paddingTop: '0px',
                paddingBottom: '0px',
            },
        },
        MuiButton: {
            root: {
                fontFamily: 'inherit',
            },
            contained: {
                '&:hover': {
                    boxShadow: 'none !important',
                    /*backgroundColor: '#3a9bea !important',*/
                },
            },
            label: {
                fontFamily: 'LeagueSpartan-Bold !important',
            }
        },
        MuiButtonBase: {
            root: {
                fontFamily: 'LeagueSpartan-Bold !important',
            },
        },
        MuiIconButton: {
            root: {
                padding: '0px !important',
            },
        },
        MuiOutlinedInput: {
            input: {

            },
        },
        MuiTextField: {
            root: {
                fontSize: '1.4em',
                backgroundColor: '#ffffff',
                margin: '0',
            },
        },
        MuiFormControl: {
            root: {
                marginTop: '0px',
                marginBottom: '16px',
            },
        },
        MuiSelect: {
            select: {
                fontSize: '1.4em',
                backgroundColor: '#ffffff',
                padding: '8px 28px 8px 8px',
            },
        },
        MuiMenuItem: {
            root: {
                fontSize: '.8em',
            },
        },
        MuiTable: {
            root: {
                marginBottom: '26px',
            }
        },
        MuiTableCell: {
            sizeSmall: {
                padding: '3px 8px 3px 8px',
                fontSize: '.75rem',
            },
            paddingCheckbox: {
                padding: '0px 2px 0px 2px !important',
            },
            root: {
                padding: '12px',
            },
        },
        MuiTableContainer: {
            root: {
                boxShadow: 'none',
            },
        },
        MuiTablePagination: {
            root: {
                marginTop: '-26px',
            },
            caption: {
                fontSize: '.8em',
            }
        },
        MuiRadio: {
            root: {
                padding: '4px',
            },
        },
        MuiDialogContent: {
            root: {
                color: '#000000',
                '&:first-child': {
                    padding: '0px',
                    paddingTop: '0px',
                },
            }
        },
        MuiDialog: {
            paperScrollPaper: {
                maxHeight: 'calc(100% - 20px)',
                overflow: 'hidden !important',
            },
            paper: {
                borderRadius: '8px',
                margin: '16px',
            },
            scrollPaper: {
                overflow: 'hidden !important',
            },
        },
        MuiPaper: {
            elevation1: {
                boxShadow: 'none',
            },
        },
    },
    palette: {
        primary: {
            light: '#1dd5f6',
            main: '#3a9bea',
            dark: '#5367df',
            contrastText: '#FFFFFF',
        },
        secondary: {
            light: '#EEEEEE',
            main: '#E0E0E0',
            dark: '#6A6A6A',
            contrastText: '#000000',
        },
        info: {
            light: '#FAFAFA',
            main: '#3a9bea',
            dark: '#0077c2',
            contrastText: '#000',
        },
    },
});

export default (themePrimary);